import React from "react";

export default class Page4 extends React.Component {
  state = {
    update: true,
    url: "",
    title: ""
  };

  // ----- Tailwind 공통 입력 스타일 -----
  inputCls =
    "w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 shadow-sm outline-none transition focus:border-sky-500 focus:ring-2 focus:ring-sky-200";

  componentDidMount = () => {
    this.initialize();
  };

  componentDidUpdate = () => {
    if (this.state.update) {
      this.initialize();

      this.setState({
        update: false
      });
    }
  };

  initialize = () => {
    // URL
    var temp = this.state.url;
    temp = this.props.obj[0].url;

    // TITLE
    var temp2 = this.state.title;
    temp2 = this.props.obj[0].title;

    this.setState({
      url: temp,
      title: temp2
    });
  };

  render() {
    return (
      <div className="content">
        <div className="mx-auto w-full max-w-3xl px-2">
          <section className="mb-6 rounded-2xl border border-gray-100 bg-white p-6 shadow-sm">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-sky-100 text-sm font-bold text-sky-600">
                ▶
              </span>
              <h3 className="text-lg font-bold text-gray-800">
                유튜브 채널 링크
              </h3>
            </div>

            <div className="space-y-4">
              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  페이지 제목
                </label>
                <input
                  type="text"
                  placeholder="예) 우리 채널"
                  defaultValue={this.state.title}
                  className={this.inputCls + " sm:max-w-xs"}
                  onChange={event => {
                    this.setState({ title: event.target.value }, () => {
                      this.props.onTitleChange(this.state.title);
                    });
                  }}
                />
              </div>

              <div>
                <label className="mb-1 block text-xs font-semibold text-gray-600">
                  유튜브 채널 주소
                </label>
                <input
                  type="url"
                  placeholder="예) https://www.youtube.com/@yourchannel"
                  defaultValue={this.state.url}
                  className={this.inputCls}
                  onChange={event => {
                    this.setState({ url: event.target.value }, () => {
                      this.props.onUrlChange(this.state.url);
                    });
                  }}
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}
